import { render, staticRenderFns } from "./DormAttendanceConfig.vue?vue&type=template&id=42433382"
import script from "./DormAttendanceConfig.vue?vue&type=script&lang=js"
export * from "./DormAttendanceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports